<script setup>
/* Props */
const props = defineProps({
  shippingDisclaimerText: {
    type: String,
    default: '',
  },
});
</script>

<template>
  <g-copy
    class="app__product__processing"
    type="small"
    v-html="props.shippingDisclaimerText"
  />
</template>
